import { ELocaleKeys } from '../../../modules/internationalization/intConstants';
import IPageSubscriberMobileTranslation from '../../../modules/internationalization/types/pages/subscriberMobile';
import { ITableFilterMultiSelect } from '../../../modules/table';
import declination from '../../../utils/declination';
import { stringFormatParams } from '../../../utils/stringFormat';

export const filterMsisdnSearchInputTooltipMsg = (
    maxLength?: number,
    tableFilter?: IPageSubscriberMobileTranslation['tableFilter'],
): ITableFilterMultiSelect['searchInputTooltipMsgCallback'] => {

    if (!maxLength || !tableFilter) return undefined;

    return searchValue => searchValue.length > maxLength
        ? stringFormatParams(tableFilter.msisdn.filtersMaxSize, {
            [ELocaleKeys.number]: maxLength,
            symbol: declination(maxLength, tableFilter.msisdn.filtersMaxSizeSymbol),
        })
        : '';
};
